import { api } from "data";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";

export const useAddBookingQuestions = () => {
  return useCustomMutation({
    url: api.questions.add_questions,
    onMutate: () => null,
    onSettled: () => null,
    onSuccess: () => null,
  });
};
